// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Error Code:",
    "error.search": "Search our knowledge base to learn more",
    dismiss: "close",
    "installation.title": "",
    "cancelation.button": "Cancel",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Initialization Failed",
      description: "We could not render the page. Please contact support.",
    },
    "EOS-UI-UE": {
      title: "Something went wrong",
      description: "Something went wrong. Please contact support.",
    },
    "EOS-IN-BC": {
      title: "Installation Failed",
      description:
        "We could not show installation progress. Please contact support.",
    },
    "EOS-IN-UE": {
      title: "Installation Failed",
      description: "Something went wrong. Please contact support",
    },
    "EOS-IN-FF": {
      title: "Installation Failed",
      description:
        "We could not connect to Epic Online Services. Please contact support.",
    },
    "EOS-IN-FF-*": {
      title: "Installation Failed",
      description:
        "We could not perform the request to Epic Online Services. Please contact support",
    },
    fallback: {
      title: "Something went wrong",
      description: "Something went wrong.  Please contact support.",
    },
  },
};
